// https://github.com/googlecreativelab/teachablemachine-community/tree/master/libraries/image
// https://blog.stackademic.com/react-tensorflow-ai-template-and-simple-project-6012071e2514
import MotionHoc from "./MotionHoc";
import ImageModelPredict from "../components/ModelTraining/ImageModelPredict";

const Team = MotionHoc(ImageModelPredict);

export default Team;
